import { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import colors from '~/constants/colors';
import styled from 'styled-components';
import { KsaAutomatedScreeningResult } from '~/types/ksa/KsaAutomatedScreeningResult';
import { isEmpty } from 'lodash';
import Section from '~/layouts/Section ';
import DecisionField from '../../components/DecisionField';

interface Props {
  result?: KsaAutomatedScreeningResult;
}

const AutomatedScreeningResult: FC<Props> = ({ result }: Props) => {
  const [t] = useTranslation('ksaReview');
  if (isEmpty(result)) return null;
  return (
    <>
      <TitleContainer>
        <Typography.Title level={5}>
          {t('Automated screening results').toUpperCase()}
        </Typography.Title>
        {result?.date && (
          <Typography.Paragraph style={{ color: colors.grey[600] }}>
            {dayjs(result?.date).format('DD.MM.YYYY HH:mm')}
          </Typography.Paragraph>
        )}
      </TitleContainer>
      <Section>
        {result?.resolution === 'IN_PROGRESS' && (
          <Typography.Paragraph>
            {t('Automated screeening is in progress. Please wait.')}
          </Typography.Paragraph>
        )}
        {result?.resolution === 'MANUAL' && (
          <Typography.Paragraph>
            {t(
              'Manual verification is in progress. Please wait for the manual decision before reviewing the appplication.'
            )}
          </Typography.Paragraph>
        )}
        {(result?.resolution === 'MATCH' ||
          result?.resolution === 'NO_MATCHES' ||
          result?.resolution === 'ERROR') && (
          <Typography.Paragraph>
            <DecisionField
              label={t('Screening resolution:')}
              value={t(`screeningResolution.${result?.resolution}`)}
              result={result?.resolution}
            />
          </Typography.Paragraph>
        )}
      </Section>
    </>
  );
};

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default AutomatedScreeningResult;
